import React, { useState } from "react";
import { useUI } from "../../context/UIContext";
import { lookupAppByPid } from "../../api";

export default function AddAppModal({ servers }) {
  const { toast, closeModal } = useUI();
  const list = Object.values(servers);
  const firstConnected = list.find((s) => s.isConnected) || list[0];
  const [code, setCode] = useState(firstConnected?.ServerCode || "");
  const [pid, setPid] = useState("");
  const [description, setDescription] = useState("");
  const [command, setCommand] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!code) return toast("Chọn máy chủ", "err");
    const p = parseInt(pid, 10);
    if (!p || p <= 0) return toast("Nhập PID hợp lệ (> 0)", "err");

    setBusy(true);
    try {
      const { ok, status, data } = await lookupAppByPid(code, p, description.trim(), command.trim());
      if (ok) {
        toast(data.message || "Đã thêm app vào giám sát", "ok", 5000);
        closeModal();
      } else if (status === 404) {
        toast(
          data.message ||
          "Không tìm thấy app trên máy chủ này, vui lòng chọn máy chủ khác",
          "err",
          6000
        );
      } else if (status === 503) {
        toast(data.message || "Máy chủ chưa kết nối", "warn", 5000);
      } else {
        toast(data.message || "Lỗi server", "err");
      }
    } catch {
      toast("Không kết nối được BackendNode", "err");
    } finally {
      setBusy(false);
    }
  };

  const onEnter = (e) => {
    if (e.key === "Enter" && !busy) submit();
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <div className="field-lbl">Máy chủ *</div>
      <select
        style={selectStyle}
        value={code}
        onChange={(e) => setCode(e.target.value)}
      >
        {list.length === 0 && <option value="">— Chưa có máy chủ —</option>}
        {list.map((s) => (
          <option key={s.ServerCode} value={s.ServerCode}>
            {s.ServerCode} {s.ServerName && s.ServerName !== s.ServerCode ? ` · ${s.ServerName}` : ""} {!s.isConnected ? " (offline)" : ""}
          </option>
        ))}
      </select>

      <div className="field-lbl">PID (Process ID) *</div>
      <input
        className="field-inp"
        type="number"
        value={pid}
        min="1"
        placeholder="VD: 12345"
        onChange={(e) => setPid(e.target.value)}
        onKeyDown={onEnter}
        autoFocus
      />

      <div className="field-lbl">Mô tả (tuỳ chọn)</div>
      <textarea
        className="field-inp"
        rows={2}
        maxLength={255}
        value={description}
        placeholder="Mô tả app này dùng làm gì…"
        onChange={(e) => setDescription(e.target.value)}
        style={{ resize: "vertical", fontFamily: "var(--font-body)", height: "auto", padding: "10px 13px" }}
      />

      <div className="field-lbl">Lệnh khởi chạy (tuỳ chọn)</div>
      <textarea
        className="field-inp"
        rows={2}
        value={command}
        placeholder="VD: C:\\app\\start.bat  hoặc  node C:\\app\\index.js"
        onChange={(e) => setCommand(e.target.value)}
        style={{ resize: "vertical", fontFamily: "var(--font-mono)", height: "auto", padding: "10px 13px" }}
      />
      <div style={{ fontSize: "11px", color: "var(--faint)", marginTop: "-10px", marginBottom: "15px", lineHeight: "1.4" }}>
        Để trống nếu chỉ giám sát. Có lệnh khởi chạy thì các nút ▶ Start / ↻ Restart mới có thể chạy lại ứng dụng trên máy chủ.
      </div>

      <div className="modal-footer" style={{ marginTop: "15px" }}>
        <button className="mbtn mbtn-cancel" onClick={closeModal} disabled={busy}>
          Huỷ
        </button>
        <button className="mbtn mbtn-primary" onClick={submit} disabled={busy}>
          {busy ? "Đang tra cứu…" : "＋ Thêm app"}
        </button>
      </div>
    </div>
  );
}

const selectStyle = {
  width: "100%",
  height: "42px",
  padding: "0 13px",
  borderRadius: "10px",
  background: "var(--surface2)",
  border: "1px solid var(--border)",
  color: "var(--text)",
  fontSize: "14px",
  outline: "none",
  marginBottom: "15px",
  boxSizing: "border-box",
  cursor: "pointer",
};
